<template>
  <v-container fluid>
    <v-layout v-if="((!isHasForecastOrg && !isHasDropshippingOrg)) || !isTenant" class="headline">{{
      (!isHasForecastOrg && !isHasDropshippingOrg) ? $t('tenantPublicBaseRates') : $t('publicBaseRates')
    }}</v-layout>
    <v-layout v-if="!displayMode">
      <v-flex md2>
        <v-btn color="primary" class="edit" @click="showBillingBaseRatesDialog">{{ $t('edit') }}</v-btn>
      </v-flex>
    </v-layout>
    <v-layout v-if="((!isHasForecastOrg && !isHasDropshippingOrg)) || !isTenant">
      <v-flex>
        <v-card>
          <v-card-text>
            <v-container fluid grid-list-lg>
              <v-layout justify-space-between v-for="item in unitRates" :key="item.sortKey">
                <v-flex md2 class="subheading">{{ item.name }}</v-flex>
                <v-flex md3 class="text-xs-right">{{ $t('inboundPerPackage') }}: </v-flex>
                <v-flex md1 class="text-xs-left">$ {{ item.packageInbound || 0 }}</v-flex>
                <v-flex md3 class="text-xs-right text-capitalize">{{ $t('itemInboundPerUnit') }}:</v-flex>
                <v-flex md1 class="text-xs-left">$ {{ item.inbound }}</v-flex>
                <v-flex md3 class="text-xs-right">{{ $t('outboundPerPackage') }}:</v-flex>
                <v-flex md1 class="text-xs-left">$ {{ item.packageOutbound || 0 }}</v-flex>
                <v-flex md3 class="text-xs-right text-capitalize">{{ $t('itemOutboundPerUnit') }}:</v-flex>
                <v-flex md1 class="text-xs-left">$ {{ item.outbound }}</v-flex>
                <v-flex md3 class="text-xs-right text-capitalize">{{ $t('itemStorageDaily') }}:</v-flex>
                <v-flex md1 class="text-xs-left">$ {{ item.storage }}</v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout v-if="(isHasForecastOrg) || !isTenant" headline mt-5 class="headline">{{
      isHasForecastOrg ? $t('tenantPublicBaseRates') : $t('PublicForecastBaseRates')
    }}</v-layout>
    <v-layout v-if="!displayMode">
      <v-flex md2>
        <v-btn color="primary" class="edit" @click="showBillingForecastBaseRatesDialog">{{ $t('edit') }}</v-btn>
      </v-flex>
    </v-layout>
    <v-layout v-if="(isHasForecastOrg) || !isTenant">
      <v-flex>
        <v-card>
          <v-card-text>
            <v-container fluid grid-list-lg>
              <v-layout justify-space-between>
                <v-flex md3 class="text-xs-right">{{ $t('inboundPerPackage') }}: </v-flex>
                <v-flex md1 class="text-xs-left">$ {{ forecastUnitRates.packageInbound || 0 }}</v-flex>
                <v-flex md3 class="text-xs-right">{{ $t('outboundPerPackage') }}: </v-flex>
                <v-flex md1 class="text-xs-left">$ {{ forecastUnitRates.packageOutbound || 0 }}</v-flex>
                <v-flex md3 class="text-xs-right">{{ $t('dailyStoragePerUnit') }}: </v-flex>
                <v-flex md1 class="text-xs-left">$ {{ forecastUnitRates.storage || 0 }}</v-flex>
              </v-layout>
              <v-layout justify-space-between>
                <v-flex md3 class="text-xs-right">{{ $t('unitFee') }}: </v-flex>
                <v-flex md1 class="text-xs-left">$ {{ forecastUnitRates.unitFee || 0 }}</v-flex>
                <v-flex md3 class="text-xs-right">{{ $t('unpackingMinimumFee') }}: </v-flex>
                <v-flex md1 class="text-xs-left">$ {{ forecastUnitRates.unpackingMinimumFee || 0 }}</v-flex>
                <v-flex md4></v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <div v-if="!displayMode">
      <v-layout class="headline mt-5">{{ $t('discountSchedule') }}</v-layout>
      <v-layout>
        <v-flex>
          <v-btn dark color="primary" class="add" @click="showEditDiscountDialog({})">{{ $t('add') }}</v-btn>
          <v-data-table
            :headers="headers"
            :items="tierDiscounts"
            item-key="reportKey"
            :pagination.sync="pagination"
            class="elevation-2 myDense"
          >
            <template v-slot:items="props">
              <td class="subheading">{{ props.item.name }}</td>
              <td class="subheading">{{ props.item.threshold }}</td>
              <td class="text-xs-left">{{ props.item.discountRate }}</td>
              <td class="text-xs-center">
                <v-layout>
                  <v-flex
                    ><v-btn dark color="primary" flat @click.stop="showEditDiscountDialog(props.item)">{{
                      $t('edit')
                    }}</v-btn></v-flex
                  >
                  <v-flex
                    ><v-btn dark color="secondary" flat @click.stop="deleteDiscount(props.item)">{{
                      $t('delete')
                    }}</v-btn></v-flex
                  >
                </v-layout>
              </td>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </div>
    <div v-if="(isHasDropshippingOrg) || !isTenant">
      <v-layout class="headline mt-5">{{ $t('dailyStoragePerUnitDropshipping') }}</v-layout>
      <v-layout>
        <v-flex>
          <v-btn v-if="!displayMode" dark color="primary" class="add" @click="showStoragePricing()">{{ $t('edit') }}</v-btn>
          <v-flex>
        <v-card>
          <v-card-text>
            <v-container fluid grid-list-lg>
              <v-layout justify-space-between v-for="item in storageWeightScope" :key="item.sortKey">
                <v-flex md3 class="text-xs-right">{{ $t('startDay') }}: </v-flex>
                <v-flex md1 class="text-xs-left">{{ item.start || 0 }}</v-flex>
                <v-flex md1 class="text-xs-right"><span>&lt;&nbsp;&nbsp; X &nbsp;&nbsp;≤</span></v-flex>
                <v-flex md3 class="text-xs-right text-capitalize">{{ $t('endDay') }}:</v-flex>
                <v-flex md1 class="text-xs-left">{{ item.end }}</v-flex>
                <v-tooltip top>
                  <template v-slot:activator="tooltip">
                      <v-flex v-on="tooltip.on" md1 class="text-xs-right">{{ $t('price') }}:</v-flex>
                  </template>
                  {{ $t('unitCubicInchHint') }}
                </v-tooltip>
                <v-flex md2 class="text-xs-left">$ {{ item.price || 0 }}</v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
        </v-flex>
        <StageStorageFeePopup
        v-if="isShowStoragePricing"
        v-model="isShowStoragePricing"
        :detail="storageWeightScope"
        :title="$t('dailyStoragePerUnitDropshipping')"
        :submit="onStoragePricingSubmitted"
        />
        
      </v-layout>
    </div>
    <div v-if="(isHasDropshippingOrg) || !isTenant">
      <v-layout class="headline mt-5">{{ $t('inboundPkgFeeForDropshipping') }}</v-layout>
      <v-layout>
        <v-flex>
          <v-btn v-if="!displayMode" dark color="primary" class="add" @click="showInboundWeightFeeSettingPopup()">{{ $t('edit') }}</v-btn>
          <v-flex>
        <v-card>
          <v-card-text>
            <v-container fluid grid-list-lg>
              <v-layout justify-space-between v-for="item in inboundWeightScope" :key="item.sortKey">
                <v-flex md3 class="text-xs-right">{{ `${$t('start')}('weight')` }}: </v-flex>
                <v-flex md1 class="text-xs-left">{{ item.start || 0 }}</v-flex>
                <v-flex md1 class="text-xs-right"><span>&lt;&nbsp;&nbsp; X &nbsp;&nbsp;≤</span></v-flex>
                <v-flex md3 class="text-xs-right text-capitalize">{{ `${$t('end')}('weight')` }}:</v-flex>
                <v-flex md1 class="text-xs-left">{{ item.end }}</v-flex>
                <v-tooltip top>
                  <template v-slot:activator="tooltip">
                      <v-flex v-on="tooltip.on" md3 class="text-xs-right">{{ $t('price') }}:</v-flex>
                  </template>
                  {{ $t('unitCLbHint') }}
                </v-tooltip>
                <v-flex md1 class="text-xs-left">$ {{ item.price || 0 }}</v-flex>
                <v-flex md3 class="text-xs-right text-capitalize">{{ `${$t('secondItemPrice')}` }}:</v-flex>
                <v-flex md1 class="text-xs-left">{{ item.secondItemPrice || 0 }}</v-flex>
              </v-layout>
              <v-layout row>
                <v-flex md3 class="text-xs-right">{{ `${$t('overSizeChargePrice')}('weight')` }}: </v-flex>
              <v-flex md1 class="text-xs-left">$ {{ inboundWeightScope[inboundWeightScope.length -1] && inboundWeightScope[inboundWeightScope.length -1].overSizeChargePrice || 0 }}</v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
        </v-flex>
        <WeightFeeSettingPopup
        v-if="isShowInboundWeightFeeSettingPopup"
        v-model="isShowInboundWeightFeeSettingPopup"
        :title="$t('inboundPkgFeeForDropshipping')"
        :detail="inboundWeightScope"
        feeType="inbound"
        :submit="onInboundWeightFeeSubmitted"
        />
      </v-layout>
    </div>
    <div v-if="(isHasDropshippingOrg) || !isTenant">
      <v-layout class="headline mt-5">{{ $t('outboundPkgFeeForDropshipping') }}</v-layout>
      <v-layout>
        <v-flex>
          <v-btn v-if="!displayMode" dark color="primary" class="add" @click="showOutboundWeightFeeSettingPopup()">{{ $t('edit') }}</v-btn>
          <v-flex>
        <v-card>
          <v-card-text>
            <v-container fluid grid-list-lg>
              <v-layout justify-space-between v-for="item in outboundWeightScope" :key="item.sortKey">
                <v-flex md2 class="text-xs-right">{{ `${$t('start')}('weight')` }}: </v-flex>
                <v-flex md1 class="text-xs-left">{{ item.start || 0 }}</v-flex>
                <v-flex md1 class="text-xs-right"><span>&lt;&nbsp;&nbsp; X &nbsp;&nbsp;≤</span></v-flex>
                <v-flex md2 class="text-xs-right text-capitalize">{{ `${$t('end')}('weight')` }}:</v-flex>
                <v-flex md1 class="text-xs-left">{{ item.end }}</v-flex>
                <v-tooltip top>
                  <template v-slot:activator="tooltip">
                      <v-flex v-on="tooltip.on" md1 class="text-xs-right">{{ $t('price') }}:</v-flex>
                  </template>
                  {{ $t('unitCLbHint') }}
                </v-tooltip>
                <v-flex md1 class="text-xs-left">$ {{ item.price || 0 }}</v-flex>
                <v-flex md3 class="text-xs-right text-capitalize">{{ `${$t('secondItemPrice')}` }}:</v-flex>
                <v-flex md1 class="text-xs-left">{{ item.secondItemPrice || 0 }}</v-flex>
                <v-flex md3 class="text-xs-right text-capitalize">{{ `${$t('subsequentUPCFirstPrice')}` }}:</v-flex>
                <v-flex md1 class="text-xs-left">{{ item.secondProductPrice || 0 }}</v-flex>
              </v-layout>
              <v-layout row>
                <v-flex md3 class="text-xs-right">{{ `${$t('overSizeChargePrice')}('weight')` }}: </v-flex>
              <v-flex md1 class="text-xs-left">$ {{ outboundWeightScope[outboundWeightScope.length -1] && outboundWeightScope[outboundWeightScope.length -1].overSizeChargePrice || 0 }}</v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
        </v-flex>
        <WeightFeeSettingPopup
        v-if="isShowOutboundWeightFeeSettingPopup"
        v-model="isShowOutboundWeightFeeSettingPopup"
        :title="$t('outboundPkgFeeForDropshipping')"
        :detail="outboundWeightScope"
        feeType="outbound"
        :submit="onOutboundWeightFeeSubmitted"
        />
      </v-layout>
    </div>
    <div v-if="(isHasDropshippingOrg) || !isTenant">
      <v-layout class="headline mt-5">{{ $t('outboundPkgMaterialFeeForDropshipping') }}</v-layout>
      <v-layout>
        <v-flex>
          <v-btn dark color="primary" class="add" @click="showMaterialFeePopup">{{ $t('edit') }}</v-btn>
          <v-flex>
            <v-card>
              <v-card-text>
                <v-container fluid grid-list-lg>
                  <v-layout justify-space-between v-for="(item, index) in materialFees" :key="index">
                    <v-flex md4 class="text-xs-right title">{{ item.name }}</v-flex>
                    <v-flex md3 class="text-xs-right">{{ $t('price') }}: </v-flex>
                    <v-flex md1 class="text-xs-left">$ {{ item.price || 0 }}</v-flex>
                    <v-flex md4 class="text-xs-left"></v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-flex>
        <FormSubmitPopup
          :title="$t('editMaterialFeeRates')"
          v-model="isShowMaterialFeePopup"
          v-if="isShowMaterialFeePopup"
          @popupClose="resetMaterialFeeForm"
          :rightMethod="updateMaterialFees"
          medium
        >
          <template v-slot:input>
            <v-container>
              <v-layout
                v-for="(item, index) in materialFeesInEdit"
                :key="index"
                justify-space-between
              >
                <v-flex md5>
                  <v-text-field
                    v-model.trim="item.name"
                    :rules="[fieldIsRequired($t('name')),validateUniqueMaterialFee($t('name'))]"
                    :label="$t('name')"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex md5>
                  <v-text-field
                    v-model.number="item.price"
                    :rules="[fieldIsRequired(), fieldIsNoLessThanZero(), fieldIsNumber()]"
                    :label="$t('price')"
                    required
                    prefix="$"
                  ></v-text-field>
                </v-flex>
                <v-flex md1 mt-3>
                  <v-btn icon @click="deleteMaterialFee(index)"><v-icon>delete</v-icon></v-btn>
                </v-flex>
              </v-layout>
              <v-layout justify-space-between>
                <v-btn color="primary" @click="addNewMaterialFee"> <v-icon>add</v-icon> {{ $t('add') }} </v-btn>
              </v-layout>
            </v-container>
          </template>
        </FormSubmitPopup>
      </v-layout>
    </div>
    <v-layout headline mt-5>{{ $t('publicOtherServiceRates') }}</v-layout>
    <v-layout v-if="!displayMode">
      <v-flex md2>
        <v-btn color="primary" class="edit" @click="showBillingOtherRatesDialog">{{ $t('edit') }}</v-btn>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex>
        <v-card>
          <v-card-text>
            <v-container fluid grid-list-lg>
              <v-layout justify-space-between>
                <v-flex md3 class="text-xs-right">{{ $t('measureDimension') }}: </v-flex>
                <v-flex md1 class="text-xs-left">$ {{ otherRates.measureDimensionFee || 0 }}</v-flex>
                <v-flex md3 class="text-xs-right">{{ $t('expeditePackage') }}: </v-flex>
                <v-flex md1 class="text-xs-left">$ {{ otherRates.expeditePackageFee }}</v-flex>
                <v-flex md3 class="text-xs-right">{{ $t('oversizedFee') }}: </v-flex>
                <v-flex md1 class="text-xs-left">$ {{ otherRates.oversizedFee || 0 }}</v-flex>
              </v-layout>
              <v-layout justify-space-between>
                <v-flex md3 class="text-xs-right">{{ $t('itemPhotoFee') }}: </v-flex>
                <v-flex md1 class="text-xs-left">$ {{ otherRates.itemPhotoFee || 0 }}</v-flex>
                <v-flex md3 class="text-xs-right">{{ $t('packageConsolidationFee') }}: </v-flex>
                <v-flex md1 class="text-xs-left">$ {{ otherRates.packageConsolidationFee || 0 }}</v-flex>
                <v-flex md3 class="text-xs-right">{{ $t('packageReinforcementFee') }}: </v-flex>
                <v-flex md1 class="text-xs-left">$ {{ otherRates.packageReinforcementFee || 0 }}</v-flex>
              </v-layout>
              <v-layout>
                <v-flex md1> </v-flex>
                <h3>{{ $t('label') }}</h3>
              </v-layout>
              <v-divider></v-divider>
              <v-layout justify-space-between>
                <v-flex md3 class="text-xs-right">{{ $t('smallItemLabelPerUnit') }}</v-flex>
                <v-flex md1 class="text-xs-left">$ {{ otherRates.smallItemLabelFee }}</v-flex>
                <v-flex md3 class="text-xs-right">{{ $t('mediumItemLabelPerUnit') }}</v-flex>
                <v-flex md1 class="text-xs-left">$ {{ otherRates.mediumItemLabelFee }}</v-flex>
                <v-flex md3 class="text-xs-right">{{ $t('largeItemLabelPerUnit') }}</v-flex>
                <v-flex md1 class="text-xs-left">$ {{ otherRates.largeItemLabelFee }}</v-flex>
              </v-layout>
              <v-layout justify-space-between>
                <v-flex md3 class="text-xs-right">{{ $t('itemLabelPerUnit', { type: $t('custom') }) }}: </v-flex>
                <v-flex md1 class="text-xs-left">$ {{ otherRates.customItemLabelFee || 0 }}</v-flex>
                <v-flex md3 class="text-xs-right">{{ $t('itemLabelPerUnit', { type: $t('nonOpenBox') }) }}: </v-flex>
                <v-flex md1 class="text-xs-left">$ {{ otherRates.nonOpenBoxItemLabelFee || 0 }}</v-flex>
                <v-flex md3 class="text-xs-right"></v-flex>
                <v-flex md1 class="text-xs-left"></v-flex>
              </v-layout>
              <v-layout>
                <v-flex md1> </v-flex>
                <h3>SN</h3>
              </v-layout>
              <v-divider></v-divider>
              <v-layout justify-space-between>
                <v-flex md3 class="text-xs-right">{{ $t('smallItemSNPerUnit') }}: </v-flex>
                <v-flex md1 class="text-xs-left">$ {{ otherRates.smallItemSNFee }}</v-flex>
                <v-flex md3 class="text-xs-right">{{ $t('mediumItemSNPerUnit') }}: </v-flex>
                <v-flex md1 class="text-xs-left">$ {{ otherRates.mediumItemSNFee }}</v-flex>
                <v-flex md3 class="text-xs-right">{{ $t('largeItemSNPerUnit') }}: </v-flex>
                <v-flex md1 class="text-xs-left">$ {{ otherRates.largeItemSNFee }}</v-flex>
              </v-layout>
              <v-layout justify-space-between>
                <v-flex md3 class="text-xs-right">{{ $t('itemSnPerUnit', { type: $t('custom') }) }}: </v-flex>
                <v-flex md1 class="text-xs-left">$ {{ otherRates.customItemSNFee || 0 }}</v-flex>
                <v-flex md3 class="text-xs-right">{{ $t('itemSnPerUnit', { type: $t('nonOpenBox') }) }}: </v-flex>
                <v-flex md1 class="text-xs-left">$ {{ otherRates.nonOpenBoxItemSNFee || 0 }}</v-flex>
                <v-flex md4></v-flex>
              </v-layout>
              <v-layout justify-space-between>
                <v-flex md3 class="text-xs-right">{{ $t('smallItemPhoto') }}: </v-flex>
                <v-flex md1 class="text-xs-left">$ {{ otherRates.smallItemPhotoFee }}</v-flex>
                <v-flex md3 class="text-xs-right">{{ $t('mediumItemPhoto') }}: </v-flex>
                <v-flex md1 class="text-xs-left">$ {{ otherRates.mediumItemPhotoFee }}</v-flex>
                <v-flex md3 class="text-xs-right">{{ $t('largeItemPhoto') }}: </v-flex>
                <v-flex md1 class="text-xs-left">$ {{ otherRates.largeItemPhotoFee }}</v-flex>
              </v-layout>
              <v-layout justify-space-between>
                <v-flex md3 class="text-xs-right">{{ $t('quantityPerSmallItemPhoto') }}: </v-flex>
                <v-flex md1 class="text-xs-left">{{ otherRates.smallItemPhotoQuantity }}</v-flex>
                <v-flex md3 class="text-xs-right">{{ $t('quantityPerMediumItemPhoto') }}: </v-flex>
                <v-flex md1 class="text-xs-left">{{ otherRates.mediumItemPhotoQuantity }}</v-flex>
                <v-flex md3 class="text-xs-right">{{ $t('quantityPerLargeItemPhoto') }}: </v-flex>
                <v-flex md1 class="text-xs-left">{{ otherRates.largeItemPhotoQuantity }}</v-flex>
              </v-layout>
              <v-layout justify-space-between>
                <v-flex md3 class="text-xs-right">{{ $t('itemPhotoPerUnit', { type: $t('nonOpenBox') }) }}: </v-flex>
                <v-flex md1 class="text-xs-left">$ {{ otherRates.nonOpenBoxItemPhotoFee || 0 }}</v-flex>
                <v-flex md3 class="text-xs-right">{{ $t('itemPhotoPerUnit', { type: $t('custom') }) }}: </v-flex>
                <v-flex md1 class="text-xs-left">$ {{ otherRates.customItemPhotoFee || 0 }}</v-flex>
                <v-flex md3 class="text-xs-right"></v-flex>
                <v-flex md1 class="text-xs-left"></v-flex>
              </v-layout>
              <v-layout justify-space-between>
                <v-flex md3 class="text-xs-right"
                  >{{ $t('quantityPerItemPhoto', { type: $t('nonOpenBox') }) }}:
                </v-flex>
                <v-flex md1 class="text-xs-left">{{ otherRates.nonOpenBoxItemPhotoQuantity }}</v-flex>
                <v-flex md3 class="text-xs-right">{{ $t('quantityPerItemPhoto', { type: $t('custom') }) }}: </v-flex>
                <v-flex md1 class="text-xs-left">{{ otherRates.customItemPhotoQuantity }}</v-flex>
                <v-flex md3 class="text-xs-right"></v-flex>
                <v-flex md1 class="text-xs-left"></v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <FormSubmitPopup
      :title="$t('editBaseBillingRates')"
      v-model="baseBillingRatesDialog"
      v-if="baseBillingRatesDialog"
      large
      @popupClose="baseBillingRatesDialog = false"
      :rightMethod="onBaseRatesChangeSubmitted"
      :rightButtonText="$t('submit')"
    >
      <template v-slot:input>
        <v-container>
          <v-layout
            justify-space-between
            v-for="item in ratesInEdit.unitRates.slice(0, 3)"
            :key="item.sortKey"
            align-center
          >
            <v-flex md2 class="subheading">{{ item.name }}</v-flex>
            <v-flex md2>
              <v-text-field
                :label="$t('inboundPerPackage')"
                prefix="$"
                :rules="[fieldIsRequired(), fieldIsNoLessThanZero(), fieldIsNumber()]"
                v-model.number="item.packageInbound"
                class="required_field"
              ></v-text-field>
            </v-flex>
            <v-flex md2>
              <v-text-field
                :label="$t('inboundPerUnit')"
                prefix="$"
                :rules="[fieldIsRequired(), fieldIsNoLessThanZero(), fieldIsNumber()]"
                v-model.number="item.inbound"
                class="required_field"
              ></v-text-field>
            </v-flex>
            <v-flex md2>
              <v-text-field
                :label="$t('outboundPerPackage')"
                prefix="$"
                :rules="[fieldIsRequired(), fieldIsNoLessThanZero(), fieldIsNumber()]"
                v-model.number="item.packageOutbound"
                class="required_field"
              ></v-text-field>
            </v-flex>
            <v-flex md2>
              <v-text-field
                :label="$t('outboundPerUnit')"
                prefix="$"
                :rules="[fieldIsRequired(), fieldIsNoLessThanZero(), fieldIsNumber()]"
                v-model.number="item.outbound"
                class="required_field"
              ></v-text-field>
            </v-flex>
            <v-flex md2>
              <v-text-field
                :label="$t('storageDaily')"
                prefix="$"
                :rules="[fieldIsRequired(), fieldIsNoLessThanZero(), fieldIsNumber()]"
                v-model.number="item.storage"
                class="required_field"
              ></v-text-field>
            </v-flex>
            <v-flex md2></v-flex>
          </v-layout>
          <v-layout justify-space-between v-for="item in addedLevelRatesInEdit" :key="item.sortKey">
            <v-flex md2>
              <v-text-field
                :label="$t('name')"
                :rules="[fieldIsRequired(), val => nameMap.get(val) <= 1 || $t('nameCanNotBeDuplicated')]"
                v-model.trim="item.name"
                class="required_field"
              ></v-text-field>
            </v-flex>
            <v-flex md2>
              <v-text-field
                :label="$t('inboundPerPackage')"
                prefix="$"
                :rules="[fieldIsRequired(), fieldIsNoLessThanZero(), fieldIsNumber()]"
                v-model.number="item.packageInbound"
                class="required_field"
              ></v-text-field>
            </v-flex>
            <v-flex md2>
              <v-text-field
                :label="`${$t('inboundPerUnit')}:`"
                prefix="$"
                :rules="[fieldIsRequired(), fieldIsNoLessThanZero(), fieldIsNumber()]"
                v-model.number="item.inbound"
                class="required_field"
              ></v-text-field>
            </v-flex>
            <v-flex md2>
              <v-text-field
                :label="$t('outboundPerPackage')"
                prefix="$"
                :rules="[fieldIsRequired(), fieldIsNoLessThanZero(), fieldIsNumber()]"
                v-model.number="item.packageOutbound"
                class="required_field"
              ></v-text-field>
            </v-flex>
            <v-flex md2>
              <v-text-field
                :label="`${$t('outboundPerUnit')}:`"
                prefix="$"
                :rules="[fieldIsRequired(), fieldIsNoLessThanZero(), fieldIsNumber()]"
                v-model.number="item.outbound"
                class="required_field"
              ></v-text-field>
            </v-flex>
            <v-flex md2>
              <v-text-field
                :label="`${$t('storageDaily')}:`"
                prefix="$"
                :rules="[fieldIsRequired(), fieldIsNoLessThanZero(), fieldIsNumber()]"
                v-model.number="item.storage"
                class="required_field"
              ></v-text-field>
            </v-flex>
            <v-flex md2>
              <v-btn small color="red" icon flat @click.stop="deleteNewRateLevel(item)"
                ><v-icon dark>cancel</v-icon></v-btn
              >
            </v-flex>
          </v-layout>
          <v-layout justify-space-between>
            <v-btn color="primary" @click="addNewRateLevel"> <v-icon>add</v-icon> {{ $t('level') }} </v-btn>
          </v-layout>
        </v-container>
      </template>
    </FormSubmitPopup>
    <FormSubmitPopup
      :title="$t('editOtherServiceBillingRates')"
      v-model="otherServiceBillingRatesDialog"
      v-if="otherServiceBillingRatesDialog"
      large
      @popupClose="otherServiceBillingRatesDialog = false"
      :rightMethod="onOtherServiceRatesChangeSubmitted"
      :rightButtonText="$t('submit')"
    >
      <template v-slot:input>
        <v-container>
          <v-layout justify-space-between>
            <v-flex md3>
              <v-text-field
                :label="$t('measureDimension')"
                prefix="$"
                :rules="[fieldIsRequired(), fieldIsNoLessThanZero(), fieldIsNumber()]"
                v-model.number="otherRatesInEdit.measureDimensionFee"
                class="required_field"
              ></v-text-field>
            </v-flex>
            <v-flex md3>
              <v-text-field
                :label="$t('expeditePackageFee')"
                prefix="$"
                :rules="[fieldIsRequired(), fieldIsNoLessThanZero(), fieldIsNumber()]"
                v-model.number="otherRatesInEdit.expeditePackageFee"
                class="required_field"
              ></v-text-field>
            </v-flex>
            <v-flex md3>
              <v-text-field
                :label="$t('oversizedFee')"
                prefix="$"
                :rules="[fieldIsRequired(), fieldIsNoLessThanZero(), fieldIsNumber()]"
                v-model.number="otherRatesInEdit.oversizedFee"
                class="required_field"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout justify-space-between>
            <v-flex md3>
              <v-text-field
                :label="$t('itemPhotoFee')"
                prefix="$"
                :rules="[fieldIsRequired(), fieldIsNoLessThanZero(), fieldIsNumber()]"
                v-model.number="otherRatesInEdit.itemPhotoFee"
                class="required_field"
              ></v-text-field>
            </v-flex>
            <v-flex md3>
              <v-text-field
                :label="$t('packageConsolidationFee')"
                prefix="$"
                :rules="[fieldIsRequired(), fieldIsNoLessThanZero(), fieldIsNumber()]"
                v-model.number="otherRatesInEdit.packageConsolidationFee"
                class="required_field"
              ></v-text-field>
            </v-flex>
            <v-flex md3>
              <v-text-field
                :label="$t('packageReinforcementFee')"
                prefix="$"
                :rules="[fieldIsRequired(), fieldIsNoLessThanZero(), fieldIsNumber()]"
                v-model.number="otherRatesInEdit.packageReinforcementFee"
                class="required_field"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <h3>{{ $t('label') }}</h3>
          <v-divider></v-divider>
          <v-layout justify-space-between>
            <v-flex md3>
              <v-text-field
                :label="$t('smallItemLabelPerUnit')"
                prefix="$"
                :rules="[fieldIsRequired(), fieldIsNoLessThanZero(), fieldIsNumber()]"
                v-model.number="otherRatesInEdit.smallItemLabelFee"
                class="required_field"
              ></v-text-field>
            </v-flex>
            <v-flex md3>
              <v-text-field
                :label="$t('mediumItemLabelPerUnit')"
                prefix="$"
                :rules="[fieldIsRequired(), fieldIsNoLessThanZero(), fieldIsNumber()]"
                v-model.number="otherRatesInEdit.mediumItemLabelFee"
                class="required_field"
              ></v-text-field>
            </v-flex>
            <v-flex md3>
              <v-text-field
                :label="$t('largeItemLabelPerUnit')"
                prefix="$"
                :rules="[fieldIsRequired(), fieldIsNoLessThanZero(), fieldIsNumber()]"
                v-model.number="otherRatesInEdit.largeItemLabelFee"
                class="required_field"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout justify-space-between>
            <v-flex md3>
              <v-text-field
                :label="$t('itemLabelPerUnit', { type: $t('custom') })"
                prefix="$"
                :rules="[fieldIsRequired(), fieldIsNoLessThanZero(), fieldIsNumber()]"
                v-model.number="otherRatesInEdit.customItemLabelFee"
                class="required_field"
              ></v-text-field>
            </v-flex>
            <v-flex md3>
              <v-text-field
                :label="$t('itemLabelPerUnit', { type: $t('nonOpenBox') })"
                prefix="$"
                :rules="[fieldIsRequired(), fieldIsNoLessThanZero(), fieldIsNumber()]"
                v-model.number="otherRatesInEdit.nonOpenBoxItemLabelFee"
                class="required_field"
              ></v-text-field>
            </v-flex>
            <v-flex md3> </v-flex>
          </v-layout>
          <h3>SN</h3>
          <v-divider></v-divider>
          <v-layout justify-space-between>
            <v-flex md3>
              <v-text-field
                :label="$t('smallItemSNPerUnit')"
                prefix="$"
                :rules="[fieldIsRequired(), fieldIsNoLessThanZero(), fieldIsNumber()]"
                v-model.number="otherRatesInEdit.smallItemSNFee"
                class="required_field"
              ></v-text-field>
            </v-flex>
            <v-flex md3>
              <v-text-field
                :label="$t('mediumItemSNPerUnit')"
                prefix="$"
                :rules="[fieldIsRequired(), fieldIsNoLessThanZero(), fieldIsNumber()]"
                v-model.number="otherRatesInEdit.mediumItemSNFee"
                class="required_field"
              ></v-text-field>
            </v-flex>
            <v-flex md3>
              <v-text-field
                :label="$t('largeItemSNPerUnit')"
                prefix="$"
                :rules="[fieldIsRequired(), fieldIsNoLessThanZero(), fieldIsNumber()]"
                v-model.number="otherRatesInEdit.largeItemSNFee"
                class="required_field"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout justify-space-between>
            <v-flex md3>
              <v-text-field
                :label="$t('itemSnPerUnit', { type: $t('custom') })"
                prefix="$"
                :rules="[fieldIsRequired(), fieldIsNoLessThanZero(), fieldIsNumber()]"
                v-model.number="otherRatesInEdit.customItemSNFee"
                class="required_field"
              ></v-text-field>
            </v-flex>
            <v-flex md3>
              <v-text-field
                :label="$t('itemSnPerUnit', { type: $t('nonOpenBox') })"
                prefix="$"
                :rules="[fieldIsRequired(), fieldIsNoLessThanZero(), fieldIsNumber()]"
                v-model.number="otherRatesInEdit.nonOpenBoxItemSNFee"
                class="required_field"
              ></v-text-field>
            </v-flex>
            <v-flex md3> </v-flex>
          </v-layout>

          <v-layout justify-space-between>
            <v-flex md3>
              <v-text-field
                :label="$t('smallItemPhotoFee')"
                prefix="$"
                :rules="[fieldIsRequired(), fieldIsNoLessThanZero(), fieldIsNumber()]"
                v-model.number="otherRatesInEdit.smallItemPhotoFee"
                class="required_field"
              ></v-text-field>
            </v-flex>
            <v-flex md3>
              <v-text-field
                :label="$t('mediumItemPhotoFee')"
                prefix="$"
                :rules="[fieldIsRequired(), fieldIsNoLessThanZero(), fieldIsNumber()]"
                v-model.number="otherRatesInEdit.mediumItemPhotoFee"
                class="required_field"
              ></v-text-field>
            </v-flex>
            <v-flex md3>
              <v-text-field
                :label="$t('largeItemPhotoFee')"
                prefix="$"
                :rules="[fieldIsRequired(), fieldIsNoLessThanZero(), fieldIsNumber()]"
                v-model.number="otherRatesInEdit.largeItemPhotoFee"
                class="required_field"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout justify-space-between>
            <v-flex md3>
              <v-text-field
                :label="$t('quantityPerSmallItemPhoto')"
                prefix="#"
                :rules="[fieldIsRequired(), fieldIsNoLessThanZero(), fieldIsNumber()]"
                v-model.number="otherRatesInEdit.smallItemPhotoQuantity"
                class="required_field"
              ></v-text-field>
            </v-flex>
            <v-flex md3>
              <v-text-field
                :label="$t('quantityPerMediumItemPhoto')"
                prefix="#"
                :rules="[fieldIsRequired(), fieldIsNoLessThanZero(), fieldIsNumber()]"
                v-model.number="otherRatesInEdit.mediumItemPhotoQuantity"
                class="required_field"
              ></v-text-field>
            </v-flex>
            <v-flex md3>
              <v-text-field
                :label="$t('quantityPerLargeItemPhoto')"
                prefix="#"
                :rules="[fieldIsRequired(), fieldIsNoLessThanZero(), fieldIsNumber()]"
                v-model.number="otherRatesInEdit.largeItemPhotoQuantity"
                class="required_field"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout justify-space-between>
            <v-flex md3>
              <v-text-field
                :label="$t('itemPhotoPerUnit', { type: $t('nonOpenBox') })"
                prefix="$"
                :rules="[fieldIsRequired(), fieldIsNoLessThanZero(), fieldIsNumber()]"
                v-model.number="otherRatesInEdit.nonOpenBoxItemPhotoFee"
                class="required_field"
              ></v-text-field>
            </v-flex>
            <v-flex md3>
              <v-text-field
                :label="$t('itemPhotoPerUnit', { type: $t('custom') })"
                prefix="$"
                :rules="[fieldIsRequired(), fieldIsNoLessThanZero(), fieldIsNumber()]"
                v-model.number="otherRatesInEdit.customItemPhotoFee"
                class="required_field"
              ></v-text-field>
            </v-flex>
            <v-flex md3> </v-flex>
          </v-layout>

          <v-layout justify-space-between>
            <v-flex md3>
              <v-text-field
                :label="$t('quantityPerItemPhoto', { type: $t('nonOpenBox') })"
                prefix="#"
                :rules="[fieldIsRequired(), fieldIsNoLessThanZero(), fieldIsNumber()]"
                v-model.number="otherRatesInEdit.nonOpenBoxItemPhotoQuantity"
                class="required_field"
              ></v-text-field>
            </v-flex>
            <v-flex md3>
              <v-text-field
                :label="$t('quantityPerItemPhoto', { type: $t('custom') })"
                prefix="#"
                :rules="[fieldIsRequired(), fieldIsNoLessThanZero(), fieldIsNumber()]"
                v-model.number="otherRatesInEdit.customItemPhotoQuantity"
                class="required_field"
              ></v-text-field>
            </v-flex>
            <v-flex md3> </v-flex>
          </v-layout>
        </v-container>
      </template>
    </FormSubmitPopup>
    <FormSubmitPopup
      :title="$t('discount')"
      v-model="editDiscountDialog"
      v-if="editDiscountDialog"
      @popupClose="editDiscountDialog = false"
      :rightMethod="editDiscount"
      :rightButtonText="$t('submit')"
    >
      <template v-slot:input>
        <v-container>
          <v-layout justify-center>
            <v-flex md6>
              <v-text-field
                :label="$t('name')"
                :rules="[fieldIsRequired('Name'), fieldCheckDup('name')]"
                v-model.number="discountInEdit.name"
                class="required_field"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout justify-center>
            <v-flex md6>
              <v-text-field
                :label="$t('threshold')"
                prefix="$"
                :rules="[fieldIsRequired('Threshold'), fieldIsNumber('Threshold'), fieldCheckDup('threshold')]"
                v-model.number="discountInEdit.threshold"
                class="required_field"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout justify-center>
            <v-flex md6>
              <v-text-field
                :label="$t('off')"
                suffix="%"
                v-model.number="discountInEdit.discountRate"
                :rules="[fieldIsRequired(), fieldIsNoLessThanZero(), fieldIsNumber()]"
                hint="Hint: 0-100"
                class="required_field"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </template>
    </FormSubmitPopup>
    <FormSubmitPopup
      :title="$t('editForecastBaseBillingRates')"
      v-model="baseBillingForecastRatesDialog"
      v-if="baseBillingForecastRatesDialog"
      large
      @popupClose="baseBillingForecastRatesDialog = false"
      :rightMethod="onForecastBaseRatesChangeSubmitted"
      :rightButtonText="$t('submit')"
    >
      <template v-slot:input>
        <v-container>
          <v-layout justify-space-between row>
            <v-flex>
              <v-text-field
                :label="$t('inboundPerPackage')"
                prefix="$"
                :rules="[fieldIsRequired(), fieldIsNoLessThanZero(), fieldIsNumber()]"
                v-model.number="forecastRatesInEdit.packageInbound"
                class="required_field"
              ></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field
                :label="$t('outboundPerPackage')"
                prefix="$"
                :rules="[fieldIsRequired(), fieldIsNoLessThanZero(), fieldIsNumber()]"
                v-model.number="forecastRatesInEdit.packageOutbound"
                class="required_field"
              ></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field
                :label="$t('dailyStoragePerUnit')"
                prefix="$"
                :hint="$t('unitCubicInchHint')"
                :rules="[fieldIsRequired(), fieldIsNoLessThanZero(), fieldIsNumber()]"
                v-model.number="forecastRatesInEdit.storage"
                class="required_field"
              ></v-text-field>
            </v-flex>
            <v-flex md3></v-flex>
          </v-layout>
          <v-layout justify-space-between row>
            <v-flex>
              <v-text-field
                :label="$t('unitFee')"
                prefix="$"
                :rules="[fieldIsRequired(), fieldIsNoLessThanZero(), fieldIsNumber()]"
                v-model.number="forecastRatesInEdit.unitFee"
                class="required_field"
              ></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field
                :label="$t('unpackingMinimumFee')"
                prefix="$"
                :rules="[fieldIsRequired(), fieldIsNoLessThanZero(), fieldIsNumber()]"
                v-model.number="forecastRatesInEdit.unpackingMinimumFee"
                class="required_field"
              ></v-text-field>
            </v-flex>
            <v-flex md6></v-flex>
          </v-layout>
        </v-container>
      </template>
    </FormSubmitPopup>
  </v-container>
</template>

<script>
import FormSubmitPopup from './FormSubmitPopup'
import { checkRules, cloneDeep } from '@/utils/tools'
import StageStorageFeePopup from './StageStorageFeePopup'
import WeightFeeSettingPopup from './WeightFeeSettingPopup'
const volumeInToCubicMeterRate = 61023.744
export default {
  name: 'BillingSettings',
  components: {
    FormSubmitPopup,
    StageStorageFeePopup,
    WeightFeeSettingPopup
  },
  mixins: [checkRules],
  data () {
    return {
      headers: [
        { text: this.$t('name'), align: 'left', sortable: true, value: 'name' },
        { text: `${this.$t('threshold')}($)`, align: 'left', sortable: true, value: 'threshold' },
        { text: `${this.$t('off')}(%)`, value: '', align: 'left', sortable: false },
        { text: this.$t('actions'), value: 'note', align: 'center', sortable: false, width: '10%' }
      ],
      ratesInEdit: {}, 
      otherRatesInEdit: {},
      discountInEdit: {},
      baseBillingRatesDialog: false,
      otherServiceBillingRatesDialog: false,
      editDiscountDialog: false,
      pagination: {
        sortBy: 'threshold',
        descending: true
      },
      addedLevelRatesInEdit: [],
      baseBillingForecastRatesDialog: false,
      forecastRatesInEdit: {},
      isShowStoragePricing: false,
      isShowInboundWeightFeeSettingPopup: false,
      inboundWeightScope: [],
      storageWeightScope: [],
      isHasForecastOrg: false,
      isHasDropshippingOrg: false,
      isShowOutboundWeightFeeSettingPopup: false,
      outboundWeightScope: [],
      isShowMaterialFeePopup: false,
      materialFeesInEdit: []
    }
  },
  mounted () {
    const rates = this.rates || {}
    this.inboundWeightScope = cloneDeep(rates.inboundWeightScope || [])
    this.storageWeightScope = cloneDeep(rates.storageWeightScope || [])
    this.outboundWeightScope = cloneDeep(rates.outboundWeightScope || [])
    this.isHasForecastOrg = this.isHasForecastOrgByWarehouse()
    this.isHasDropshippingOrg = this.isHasDropshippingOrgByWarehouse()
  },
  computed: {
    materialFees () {
      return this.rates.materialFees || []
    },
    isTenant () {
      return !!this.$store.getters.activeOrganization
    },
    warehouseLimitedInfo () {
      return this.$store.getters.warehouseLimitedInfo
    },
    rates () {
      return this.warehouseLimitedInfo.rates || {}
    },
    unitRates () {
      return this.rates.unitRates || []
    },
    forecastUnitRates () {
      return this.rates.forecastUnitRates || {}
    },
    otherRates () {
      return this.warehouseLimitedInfo.otherRates || {}
    },
    tierDiscounts () {
      let {tierDiscounts} = this.warehouseLimitedInfo
      if (tierDiscounts) {
        return Object.keys(tierDiscounts).map(key => {
          return {key, ...tierDiscounts[key]}
        })
      } else return []
    },
    usedLevelSet () {
      return new Set(Object.values(this.$store.getters.upcMap).map(item => item.size))
    },
    nameMap () {
      let map = new Map()
      this.addedLevelRatesInEdit.forEach(item => {
        if (!map.has(item.name)) {
          map.set(item.name, 0)
        }
        map.set(item.name, map.get(item.name) + 1)
      })
      return map
    }
  },
  methods: {
    validateUniqueMaterialFee (name) {
      return (v) => {
        const filtered = this.materialFeesInEdit.filter(item => item.name === v)
        return filtered.length <= 1 || `Duplicated ${name}, please check.`
      }
    },
    showMaterialFeePopup () {
      this.materialFeesInEdit = cloneDeep(this.rates.materialFees || [])
      this.isShowMaterialFeePopup = true
    },
    resetMaterialFeeForm () {
      this.isShowMaterialFeePopup = false
      this.materialFeesInEdit = []
    },
    async updateMaterialFees () {
      const rates = cloneDeep(this.rates)
      rates.materialFees = this.materialFeesInEdit
      return this.$store.dispatch('updateBillingRates', rates)
        .then(() => {
          this.materialFeesInEdit = cloneDeep(this.rates.materialFees)
        })
    },
    addNewMaterialFee () {
      this.materialFeesInEdit.push({ name: '', price: 0 })
    },
    deleteMaterialFee (index) {
      this.materialFeesInEdit.splice(index, 1)
    },
    isHasForecastOrgByWarehouse () {
      const warehouseKey = this.warehouseLimitedInfo?.key
      const {featureInboundForecastPkg = []} = this.$store.getters.tenant || {}
      return this.isTenant && featureInboundForecastPkg.includes(warehouseKey)
    },
    isHasDropshippingOrgByWarehouse () {
      const warehouseKey = this.warehouseLimitedInfo?.key
      const {featureInboundForecastDropshipping = []} = this.$store.getters.tenant || {}
      return this.isTenant && featureInboundForecastDropshipping.includes(warehouseKey)
    },
    showInboundWeightFeeSettingPopup () {
      this.inboundWeightScope = cloneDeep(this.rates.inboundWeightScope || [
        { start: 0, end: 30, price: 0.5 / volumeInToCubicMeterRate, secondItemPrice: 0 },
        { start: 30, end: 50, price: 0.6 / volumeInToCubicMeterRate, secondItemPrice: 0 },
        { start: 50, end: 100, price: 0.9 / volumeInToCubicMeterRate, secondItemPrice: 0 },
        { start: 100, end: Infinity, price: 1.5 / volumeInToCubicMeterRate, secondItemPrice: 0 }
      ])
      this.isShowInboundWeightFeeSettingPopup = true
    },
    onInboundWeightFeeSubmitted (data) {
      const rates = cloneDeep(this.rates)
      rates.inboundWeightScope = data
      return this.$store.dispatch('updateBillingRates', rates)
        .then(() => {
          this.inboundWeightScope = cloneDeep(this.rates.inboundWeightScope)
        })
    },
    showOutboundWeightFeeSettingPopup () {
      this.outboundWeightScope = cloneDeep(this.rates.outboundWeightScope || [
        { start: 0, end: 20, price: 1.6 / volumeInToCubicMeterRate, secondItemPrice: 0 },
        { start: 20, end: 50, price: 2.4 / volumeInToCubicMeterRate, secondItemPrice: 0 },
        { start: 50, end: 100, price: 4.0 / volumeInToCubicMeterRate, secondItemPrice: 0 }
      ])
      this.isShowOutboundWeightFeeSettingPopup = true
    },
    onOutboundWeightFeeSubmitted (data) {
      const rates = cloneDeep(this.rates)
      rates.outboundWeightScope = data
      return this.$store.dispatch('updateBillingRates', rates)
        .then(() => {
          this.outboundWeightScope = cloneDeep(this.rates.outboundWeightScope)
        })
    },
    onStoragePricingSubmitted (data) {
      const rates = cloneDeep(this.rates)
      rates.storageWeightScope = data
      return this.$store.dispatch('updateBillingRates', rates)
        .then(() => {
          this.storageWeightScope = this.rates.storageWeightScope
        })
    },
    showStoragePricing () {
      this.storageWeightScope = cloneDeep(this.rates.storageWeightScope || [
        { start: 0, end: 30, price: 0 },
        { start: 30, end: 60, price: 0.45 / volumeInToCubicMeterRate },
        { start: 60, end: Infinity, price: 1.5 / volumeInToCubicMeterRate }
      ])
      this.isShowStoragePricing = true
    },
    onForecastBaseRatesChangeSubmitted () {
      let rates = this.rates
      rates.forecastUnitRates = this.forecastRatesInEdit
      return this.$store.dispatch('updateBillingRates', rates)
    },
    showBillingForecastBaseRatesDialog () {
      this.baseBillingForecastRatesDialog = true
      this.forecastRatesInEdit = {...this.forecastUnitRates}
    },
    showBillingBaseRatesDialog () {
      this.baseBillingRatesDialog = true
      this.ratesInEdit = cloneDeep(this.rates)
      if (this.unitRates.length > 3) {
        this.addedLevelRatesInEdit = cloneDeep(this.unitRates.slice(3))
      }
    },
    showBillingOtherRatesDialog () {
      this.otherServiceBillingRatesDialog = true
      this.otherRatesInEdit = {...this.otherRates}
    },
    showEditDiscountDialog (item) {
      this.editDiscountDialog = true
      this.discountInEdit = {...item}
    },
    onBaseRatesChangeSubmitted () {
      this.ratesInEdit.unitRates = [...this.ratesInEdit.unitRates.slice(0, 3), ...this.addedLevelRatesInEdit]
      return this.$store.dispatch('updateBillingRates', this.ratesInEdit)
    },
    onOtherServiceRatesChangeSubmitted () {
      return this.$store.dispatch('updateBillingOtherRates', this.otherRatesInEdit)
    },
    editDiscount () {
      return this.$store.dispatch('editTierDiscount', this.discountInEdit)
    },
    deleteDiscount (item) {
      if (!confirm(this.$t('confirmDeleteDiscount'))) return Promise.resolve()
      return this.$store.dispatch('editTierDiscount', {...item, isDelete: true})
    },
    fieldCheckDup (fieldName) {
      return (v) => !this.tierDiscounts.some(item => (item.key !== this.discountInEdit.key && item[fieldName] === v)) || `Duplicated ${fieldName}, please check.`
    },
    addNewRateLevel () {
      if (this.addedLevelRatesInEdit.length) {
        this.addedLevelRatesInEdit.push({
          sortKey: this.addedLevelRatesInEdit[this.addedLevelRatesInEdit.length - 1].sortKey + 1
        })
      } else {
        this.addedLevelRatesInEdit.push({
          sortKey: 4
        })
      }
    },
    deleteNewRateLevel (item) {
      if (!confirm(this.$t('confirmDeleteLevel'))) return
      if (this.usedLevelSet.has(item.sortKey)) return alert(this.$t('levelBeingUsedCannotBeDeleted'))
      this.addedLevelRatesInEdit = this.addedLevelRatesInEdit.filter(level => {
        return item.sortKey !== level.sortKey
      })
    }
  },
  props: {
    displayMode: {
      type: Boolean,
      default: () => {
        return false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/BillingSettings.vue